import axiosInstance from '@/shared/api/axios';
import type { ApiChargesMyGetResponse, ParcelCharge } from '@/shared/types/api/charges';

export const apiParcelChargesGet = async (parcelId: string): Promise<ParcelCharge[]> => {
  const { data } = await axiosInstance.get<ParcelCharge[]>(`/parcels/${parcelId}/charges`);
  return data;
};

export const apiChargesMyGet = async (): Promise<ApiChargesMyGetResponse> => {
  const { data } = await axiosInstance.get<ApiChargesMyGetResponse>('/charges/my');
  return data;
};
